import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import openNotification from '../../components/Common/OpenNotification';
import { CLEAR_ADMIN_CACHE } from '../../api/endpoints';

const initialState = {
  loading: false,
  response: null,
  error: null,
};

export const clearAdminCache = createAsyncThunk(
  'admin/clearAdminCache',
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        CLEAR_ADMIN_CACHE,
        payload
      );
      return response.data;
    } catch (error) {
      openNotification(
        error?.response?.data?.message || 'Something went wrong.'
      );
      return rejectWithValue(
        error?.response?.data?.message || 'Something went wrong.'
      );
    }
  }
);

const adminCacheSlice = createSlice({
  name: 'adminCache',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(clearAdminCache.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(clearAdminCache.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(clearAdminCache.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default adminCacheSlice.reducer;